<div cdk-overlay-origin class="mat-drop-down-trigger" (click)="togglePanel()" #origin="cdkOverlayOrigin" #trigger>
  <div class="mat-drop-down-value">
    @switch (empty) {
      @case (true) {
        <span class="mat-drop-down-placeholder">{{ placeholder || '\u00A0' }}</span>
      }
      @case (false) {
        <span class="mat-drop-down-value-text">
          @switch (!!customTrigger) {
            @default {
              <span [title]="triggerValue">{{ triggerValue || '\u00A0' }}</span>
            }
            @case (true) {
              <ng-content select="nimbus-mat-drop-down-trigger"></ng-content>
            }
          }
        </span>
      }
    }
  </div>
</div>

<ng-template
  cdk-connected-overlay
  cdkConnectedOverlayLockPosition
  cdkConnectedOverlayHasBackdrop
  [cdkConnectedOverlayPanelClass]="panelClass"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayScrollStrategy]="_scrollStrategy"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isPanelOpen"
  [cdkConnectedOverlayPositions]="_positions"
  [cdkConnectedOverlayWidth]="_triggerRect?.width || null"
  [cdkConnectedOverlayOffsetY]="_offsetY"
  (backdropClick)="close()"
  (attach)="onAttached()"
  (detach)="close()"
>
  <div class="mat-drop-down-panel-wrap" [@transformPanelWrap] [class.scalable]="isScalable">
    <div
      #panel
      tabindex="-1"
      class="mat-drop-down-panel"
      [@transformPanel]="'opened'"
      (@transformPanel.done)="_panelDoneAnimatingStream.next($event.toState)"
    >
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
